import type { ReactNode } from 'react';

export const symbol_recent_patient: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-160q-25 0-42.5-17.5T160-220v-34q0-38 19-65t49-41q67-30 128.5-45T480-420q21 0 42 1.5t42 5.5q11 2 18.5 11t7.5 21q0 13-9.5 20.5T558-355q-20-3-39-4t-39-1q-57 0-110.5 12T252-306q-14 7-23 21.5t-9 30.5v34h340q13 0 21.5 8.5T590-190q0 13-8.5 21.5T560-160H220Zm0-60h370-370Zm152-303q-42-42-42-108t42-108q42-42 108-42t108 42q42 42 42 108t-42 108q-42 42-108 42t-108-42Zm172.5-43.5Q570-592 570-631t-25.5-64.5Q519-721 480-721t-64.5 25.5Q390-670 390-631t25.5 64.5Q441-541 480-541t64.5-25.5ZM480-631Zm250 421h-50q-13 0-21.5-8.5T650-240v-160q0-13 8.5-21.5T680-430h147q13 0 19.5 11t1.5 22l-64 127h40q13 0 20 11.5t0 22.5L744-62q-3 5-8.5 3.5T730-66v-144Z"
		/>
	</svg>
);
